import ReactMarkdown from "react-markdown"
import remarkGfm from "remark-gfm"

const shiftHeading = (level) => ({ children, ...props }) => {
  const safeLevel = Math.min(level + 1, 6)
  const Tag = `h${safeLevel}`

  return (
    <Tag {...props} className={`markdown-h${safeLevel}`}>
      {children}
    </Tag>
  )
}

const ReactMarkdownMod_2 = ({ children, components = {} }) => {
  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      components={{
        h1: shiftHeading(1), // this becomes h2 and so on
        h2: shiftHeading(1), // this remains h2
        h3: shiftHeading(2),
        h4: shiftHeading(3),
        h5: shiftHeading(4),
        h6: shiftHeading(5),




        table: ({ children }) => (
          <div className="overflow-x-auto my-4">
            <table className="w-full text-sm border-collapse border border-slate-200 dark:border-slate-700">
              {children}
            </table>
          </div>
        ),

        thead: ({ children }) => (
          <thead className="bg-slate-100 dark:bg-slate-700">
            {children}
          </thead>
        ),

        th: ({ children }) => (
          <th className="border border-slate-200 dark:border-slate-600 px-3 py-2 text-left font-semibold">
            {children}
          </th>
        ),

        td: ({ children }) => (
          <td className="border border-slate-200 dark:border-slate-600 px-3 py-2">
            {children}
          </td>
        ),


        a: ({ ...props }) => (
          <a
            {...props}
            // onClick={(e) => e.stopPropagation()}
            target="_blank"
            rel="noopener noreferrer ugc"
            className="text-teal-500 hover:underline"
          />
        ),

        // allow overrides from parent
        ...components,
      }}
    >
      {children}
    </ReactMarkdown>
  )
}

export default ReactMarkdownMod_2